import { fetchSite } from 'redux/thunks/Site'
import { fetchUser } from 'redux/thunks/User'
import { fetchfeatures } from 'redux/thunks/Features'
import { fetchHomePageRevision } from 'redux/thunks/HomePageRevision'
import { setAdapter } from 'redux/slices/User'
import getToken from 'lib/authentication/GetToken'
import { AppDispatch } from 'redux/store'
import { getBaseURL } from 'lib/utility/GetBaseUrl'
import librariesApi from 'api/ApiActions/Common/Libraries'
import { setIntercomDetails } from 'redux/slices/Libraries'

export const setToken = (dispatch: AppDispatch) => {
  const token = getToken()
  const host = getBaseURL()

  dispatch(setAdapter({ host, token }))
}

export const setIntercomData = async (dispatch: AppDispatch) => {
  const response = await librariesApi.fetchIntercom()
  response?.response?.status !== 404
    ? dispatch(setIntercomDetails(response))
    : dispatch(setIntercomDetails({}))
}

export const fetchInitialData = async (dispatch: AppDispatch) => {
  setToken(dispatch)
  await setIntercomData(dispatch)

  dispatch(fetchfeatures())
  dispatch(fetchHomePageRevision())

  // Fetch data sequentially
  await dispatch(fetchSite())
  await dispatch(fetchUser())

  // return true, after all fetches are complete
  return true
}
